import { object, string, array } from "yup";

export default intl => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });
  return object().shape({
    codename: string().required(requiredText),
    description: string().required(requiredText),
    categoryIds: array()
      .of(string().required(requiredText))
      .nullable(),
  });
};
